<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="(key) => toggleTool(key)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class DownloadMenus extends Vue {
        tempDisable = !appConfig.isBuild;
        closeDrop() {
            this.$emit("closeDrop");
        }
        get toolList() {
            return this.$store.state.ui.toolList;
        }
        set toolList(v) {
            this.$store.commit("setStatus", {
                type: "toolList",
                data: v,
            });
        }
        get menuList() {
            return {
                list: [
                    { key: "fontBtn", label: this.$t("text"), checked: this.toolList.contains("fontBtn"), shortcut: "Ctrl+2" },
                    { key: "connector", label: this.$t("connector"), checked: this.toolList.contains("connector") },
                    { key: "colorFill", label: this.$t("fillColor"), checked: this.toolList.contains("colorFill") },
                    { key: "colorline", label: this.$t("lineColor"), checked: this.toolList.contains("colorline") },
                    { key: "lineSize", label: this.$t("lineSize"), checked: this.toolList.contains("lineSize") },
                    { key: "lineType", label: this.$t("lineType"), checked: this.toolList.contains("lineType") },
                    { key: "lineAnime", label: this.$t("lineAnime"), checked: this.toolList.contains("lineAnime") },
                    { key: "leftArrow", label: this.$t("leftArrow"), checked: this.toolList.contains("leftArrow") },
                    { key: "rightArrow", label: this.$t("rightArrow"), checked: this.toolList.contains("rightArrow") },
                    // { key: "acquiesceStyle", label: this.$t("acquiesceStyle"), checked: this.toolList.contains("acquiesceStyle") },
                    // { key: "layout", label: this.$t("layout"), checked: this.toolList.contains("layout") },
                    { key: "layer", label: this.$t("layer"), checked: this.toolList.contains("layer") },
                    { key: "mirror", label: this.$t("mirror"), checked: this.toolList.contains("mirror") },
                    // { key: "align", label: this.$t("textAlign"), checked: this.toolList.contains("align") },
                    { key: "compose", label: this.$t("compose"), checked: this.toolList.contains("compose") },
                    { key: "protect", label: this.$t("protect"), checked: this.toolList.contains("protect") },
                    // { key: "theme", label: this.$t("theme"), checked: this.toolList.contains("theme") },
                    // { key: "option", label: this.$t("option"), checked: this.toolList.contains("option") },
                    { key: "autoFormat", label: this.$t("autoFormatting"), checked: this.toolList.contains("autoFormat") },
                    { key: "pageset", label: this.$t("pageset"), checked: this.toolList.contains("pageset") },
                    { key: "search", label: this.$t("search"), checked: this.toolList.contains("search") },
                ],
            };
        }
        toggleTool(str) {
            let index = this.toolList.indexOf(str);
            let baseList = [
                "fontBtn",
                "connector",
                "colorFill",
                "colorline",
                "lineSize",
                "lineType",
                "leftArrow",
                "rightArrow",
                "layer",
                "mirror", // 翻转
                "compose",
                "protect",
                "autoFormat",
                "pageset",
                "search",
            ];
            let baseIndex = baseList.indexOf(str);
            if (index != -1) {
                this.toolList.splice(index, 1);
            } else {
                this.toolList.splice(baseIndex, 0, str);
            }
            localStorage && localStorage.setItem("toolbar", JSON.stringify(this.toolList));
            // this.closeDrop();
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "text": "添加文本",
    "textAlign": "布局、对齐、等宽高",
    "layout": "位置、宽高、角度",
    "layer": "层级",
    "fillColor": "填充颜色",
    "lineColor": "线条颜色",
    "compose": "组合",
    "search": "查找",
    "protect": "锁定",
    "option": "特殊设置",
    "acquiesceStyle": "线条样式",
    "theme": "快速样式",
    "connector": "连接线",
    "mirror": "翻转",
    "autoFormatting": "一键美化",
    "pageset": "页面设置",
    "leftArrow": "起点",
    "rightArrow": "终点",
    "lineSize": "粗细",
    "lineType": "虚线",
    "lineAnime": "流向动画"
  },
  "en": {
    "text": "Add Text",
    "textAlign": "Layout, Alignment, Aspect Ratio",
    "layout": "Position, Width, Height, Angle",
    "layer": "Layer",
    "fillColor": "Fill Color",
    "lineColor": "Line Color",
    "compose": "Group",
    "search": "Find",
    "protect": "Locked",
    "option": "Exceptional Settings",
    "acquiesceStyle": "Line Style",
    "theme": "Quick Style",
    "connector": "Connector",
    "mirror": "Flip",
    "autoFormatting": "Auto Formatting",
    "pageset": "Page Settings",
    "leftArrow": "Start",
    "rightArrow": "End",
    "lineSize": "Line Weight",
    "lineType": "Line Type",
    "lineAnime": "Flow Animation"
  },
  "fr": {
    "text": "Texte",
    "textAlign": "Alignement",
    "layout": "Attribut",
    "layer": "Superposer",
    "fillColor": "Couleur de remplissage",
    "lineColor": "Couleur du trait",
    "compose": "Grouper",
    "search": "Rechercher",
    "protect": "Protéger",
    "option": "Paramètres spéciaux",
    "acquiesceStyle": "Style de ligne",
    "theme": "Style rapide",
    "connector": "Ligne de connexion",
    "mirror": "Pivoter",
    "autoFormatting": "Formatage automatique",
    "pageset": "Paramètres de Page",
    "leftArrow": "Début",
    "rightArrow": "Fin",
    "lineSize": "Epaisseur de la ligne",
    "lineType": "Type de ligne",
    "lineAnime": ""
  },
  "de": {
    "text": "Text",
    "textAlign": "Ausrichten",
    "layout": "Eigenschaft",
    "layer": "Ebene",
    "fillColor": "Farbe eingeben",
    "lineColor": "Liniensfarbe",
    "compose": "Gruppieren",
    "search": "Suchen",
    "protect": "Schützen",
    "option": "Ausserordentliche Einstellungen",
    "acquiesceStyle": "Linien Style",
    "theme": "Quick Style",
    "connector": "Verbindung",
    "mirror": "Spiegeln",
    "autoFormatting": "Automatisch formatieren",
    "pageset": "Seiteneinstellung",
    "leftArrow": "Startpunkt",
    "rightArrow": "Endpunkt",
    "lineSize": "Linienstärke",
    "lineType": "Linientyp",
    "lineAnime": ""
  },
  "jp": {
    "text": "テキスト",
    "textAlign": "テキストの揃え方",
    "layout": "レイアウト",
    "layer": "レイヤー",
    "fillColor": "塗りつぶし",
    "lineColor": "線の色",
    "compose": "グループ化",
    "search": "検索",
    "protect": "ロック",
    "option": "特別な設定",
    "acquiesceStyle": "線のスタイル",
    "theme": "クイック書式",
    "connector": "コネクター",
    "mirror": "反転",
    "autoFormatting": "自動フォーマット",
    "pageset": "ページ設定",
    "leftArrow": "出発点",
    "rightArrow": "終点",
    "lineSize": "太さ",
    "lineType": "線種",
    "lineAnime": ""
  },
  "es": {
    "text": "Añadir texto",
    "textAlign": "Disposición, alineación, relación de aspecto",
    "layout": "Posición, anchura, altura, ángulo",
    "layer": "Capa",
    "fillColor": "Color de relleno",
    "lineColor": "Color de línea",
    "compose": "Grupo",
    "search": "Encuentra",
    "protect": "Proteger",
    "option": "Ajustes excepcionales",
    "acquiesceStyle": "Estilo de línea",
    "theme": "Estilo rápido",
    "connector": "Conector",
    "mirror": "Girar",
    "autoFormatting": "Formateo automático",
    "pageset": "Configuración de la página",
    "leftArrow": "Punto de partida",
    "rightArrow": "Punto final",
    "lineSize": "Grosor de la línea",
    "lineType": "Tipo de Línea",
    "lineAnime": ""
  },
  "pt": {
    "text": "Adicionar Texto",
    "textAlign": "Layout, Alinhamento, Largura e Altura Iguais",
    "layout": "Posição, Largura e Altura, ângulo",
    "layer": "Camada",
    "fillColor": "Cor de Preenchimento",
    "lineColor": "Cor da Linha",
    "compose": "Agrupar",
    "search": "Procurar",
    "protect": "Bloqueado",
    "option": "Configurações Excepcionais",
    "acquiesceStyle": "Estilo de Linha",
    "theme": "Estilo Rápido",
    "connector": "Conector",
    "mirror": "Inverter",
    "autoFormatting": "Formatação Automática",
    "pageset": "Configurações de Página",
    "leftArrow": "Início",
    "rightArrow": "Fim",
    "lineSize": "Espessura da Linha",
    "lineType": "Tipo de Linha",
    "lineAnime": ""
  },
  "it": {
    "text": "Aggiungi testo",
    "textAlign": "Layout, Allineamento, Proporzioni",
    "layout": "Posizione, Larghezza, Altezza, Angolo",
    "layer": "Livello",
    "fillColor": "Colore di riempimento",
    "lineColor": "Colore linea",
    "compose": "Raggruppa",
    "search": "Cercare",
    "protect": "Proteggere",
    "option": "Impostazioni speciali",
    "acquiesceStyle": "Stile della linea",
    "theme": "Stile veloce",
    "connector": "Linea di collegamento",
    "mirror": "Capovolgi",
    "autoFormatting": "Formattazione automatica",
    "pageset": "Impostazioni Pagina",
    "leftArrow": "Inizio",
    "rightArrow": "Fine",
    "lineSize": "Spessore della linea",
    "lineType": "Tipo di linea",
    "lineAnime": ""
  },
  "tw": {
    "text": "添加文本",
    "textAlign": "佈局、對齊、等寬高",
    "layout": "位置、寬高、角度",
    "layer": "層級",
    "fillColor": "填充顏色",
    "lineColor": "線條顏色",
    "compose": "組合",
    "search": "查找",
    "protect": "鎖定",
    "option": "特殊設置",
    "acquiesceStyle": "線條樣式 ",
    "theme": "快速設置",
    "connector": "連接線",
    "mirror": "鏡像",
    "autoFormatting": "一鍵美化",
    "pageset": "頁面設置",
    "leftArrow": "起點",
    "rightArrow": "終點"
  }
}
</i18n>
